import { $axios } from "lib/axios";
import { TLoginReq } from "types/auth/authTypes";

export const postLogin = async (params: TLoginReq) => {
  const res = await $axios.post("/login", params);
  return res.data;
};

export const postCorporationLogin = async (params: TLoginReq) => {
  const res = await $axios.post("/login/corporation", params);
  return res.data;
};

export const getAuth = async () => {
  const res = await $axios.get("/auth");
  return res.data;
};
